import React, { useCallback } from 'react';

import { TypographyVariants } from 'src/types/typography-variants.enum';
import Typography from 'src/components/typography/Typography';

import AddAccountViewTemplate from 'src/components/atomic/pages/addAccounts/AddAccountViewTemplate';
import LiteralsService from 'src/services/literals/LiteralsService';
import ManualAccountService from 'src/services/manualAccount.service';
import { ManualAccountType } from 'src/types/manualAccount.model';
import Callout from 'src/components/atomic/atoms/callout/Callout';
import { DLSSize } from 'src/types/dls-size.enum';
import WhyShouldYouConnectTooltip from 'src/components/atomic/atoms/tooltips/whyYouShouldConnectTooltip/WhyShouldYouConnectTooltip';
import { IconBank } from '@americanexpress/dls-react';
import { PropertyAndAssetsAddAccountViewModel } from 'src/types/view-models/addAccount/addAccount.view.model';
import NavigationService from 'src/services/navigation.service';

export default function PropertyAndAssetsAddAccountView({
    handleBack,
    handleReloadUser,
    editManualAccount,
    history
}: PropertyAndAssetsAddAccountViewModel): JSX.Element {
    const onSubmitCallback: () => Promise<void> = useCallback(async () => {
        await handleReloadUser();
        void NavigationService.goTo(history, '/drawer/profile');
    }, []);

    return (
        <AddAccountViewTemplate
            title={LiteralsService.getLiteral('Onboarding.propertyAndAssets.title')}
            accountTypes={ManualAccountService.propertyAndAssetsAccountTypes}
            initialType={ManualAccountType.Cash}
            editManualAccount={editManualAccount}
            callout={
                <Callout
                    icon={<IconBank size={DLSSize.MEDIUM} />}
                    heading={LiteralsService.getLiteral('Onboarding.propertyAndAssets.formCalloutHeading')}
                >
                    <Typography variant={TypographyVariants.BODY}>
                        {LiteralsService.getLiteral('Onboarding.propertyAndAssets.formCalloutBody')}
                    </Typography>
                    <WhyShouldYouConnectTooltip withText />
                </Callout>
            }
            handleBack={handleBack}
            onSubmitCallback={onSubmitCallback}
        />
    );
}
